<template>
  <div style="margin:auto" :style="{ width: $vuetify.breakpoint.smAndDown ? '80vw' : '50vw' }">
    <h2 class="pb-3">Срок хранения сессии подписания завершён.</h2>
    <p>Все данные сессии: ФИО и ID участников, документы и другие служебные данные безвозвратно удалены.</p>
    <p>Результат завершения сессии подписания был направлен всем участникам соответствующим образом.</p>
  </div>
</template>

<script>
export default {
  name: 'EmptyTransactionNotification',
  components: {
  },
  data: () => ({}),
}
</script>